/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Timeline_Font_SizeInputs */

const en_options_editor_timeline_font_size = /** @type {(inputs: Options_Editor_Timeline_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Font Size (px)`)
};

const fr_options_editor_timeline_font_size = /** @type {(inputs: Options_Editor_Timeline_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille de police (px)`)
};

const de_options_editor_timeline_font_size = /** @type {(inputs: Options_Editor_Timeline_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schriftgröße (px)`)
};

const it_options_editor_timeline_font_size = /** @type {(inputs: Options_Editor_Timeline_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensione carattere (px)`)
};

const ru_options_editor_timeline_font_size = /** @type {(inputs: Options_Editor_Timeline_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Размер шрифта (пиксели)`)
};

const es_options_editor_timeline_font_size = /** @type {(inputs: Options_Editor_Timeline_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño de fuente (px)`)
};

const zh_cn2_options_editor_timeline_font_size = /** @type {(inputs: Options_Editor_Timeline_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字体大小（像素）`)
};

const ja_options_editor_timeline_font_size = /** @type {(inputs: Options_Editor_Timeline_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォントサイズ（ピクセル）`)
};

const hi_options_editor_timeline_font_size = /** @type {(inputs: Options_Editor_Timeline_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ॉन्ट आकार (px)`)
};

const pt_pt2_options_editor_timeline_font_size = /** @type {(inputs: Options_Editor_Timeline_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho da fonte (px)`)
};

/**
* | output |
* | --- |
* | "Font Size (px)" |
*
* @param {Options_Editor_Timeline_Font_SizeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_timeline_font_size = /** @type {((inputs?: Options_Editor_Timeline_Font_SizeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Timeline_Font_SizeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_timeline_font_size(inputs)
	if (locale === "de") return de_options_editor_timeline_font_size(inputs)
	if (locale === "it") return it_options_editor_timeline_font_size(inputs)
	if (locale === "ru") return ru_options_editor_timeline_font_size(inputs)
	if (locale === "es") return es_options_editor_timeline_font_size(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_timeline_font_size(inputs)
	if (locale === "ja") return ja_options_editor_timeline_font_size(inputs)
	if (locale === "hi") return hi_options_editor_timeline_font_size(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_timeline_font_size(inputs)
	return en_options_editor_timeline_font_size(inputs)
});